import PropTypes from 'prop-types'
import React from 'react'
import { Col, Row, Card } from 'react-bootstrap'

const Dashboard = () => (
  <React.Fragment>
    <Row className="mb-5">
      <React.Fragment>
        <Col xs="12" md="6" className="pb-3 px-2">
          <Card className="dashboard-card cursor-pointer bg-blue">
            <Card.Body>
              <div className="text-center">
                {/* <h2 className="font-weight-bold">20</h2> */}
                <p className="mb-0">Jumlah Berita</p>
              </div>
            </Card.Body>
          </Card>
        </Col>
        {/* <Col xs="12" md="6" className="pb-3 px-2">
          <Card className="dashboard-card cursor-pointer bg-blue">
            <Card.Body>
              <div className="text-center">
                <h2 className="font-weight-bold">10</h2>
                <p className="mb-0">Jumlah Mitra</p>
              </div>
            </Card.Body>
          </Card>
        </Col> */}
      </React.Fragment>
    </Row>
  </React.Fragment>
)

Dashboard.propTypes = {

}

export default Dashboard
